import { render, staticRenderFns } from "./ButtonTable.vue?vue&type=template&id=2f986ce4&scoped=true"
import script from "./ButtonTable.vue?vue&type=script&lang=js"
export * from "./ButtonTable.vue?vue&type=script&lang=js"
import style0 from "./ButtonTable.vue?vue&type=style&index=0&id=2f986ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f986ce4",
  null
  
)

export default component.exports